export const environment = {
  production: false,
  //hostUrl: "https://localhost:5001/",
  hostUrl: 'https://dev.api.riskallay.com/',
};
